import React, { FunctionComponent, memo } from "react";
import { useIntl } from "react-intl";
import { isEqual } from "lodash";

import { PlcPv } from "./types";

import Source from "./components/Source";
import SourceMetric from "./components/SourceMetric";


interface IProps {
  data: PlcPv;
}


const SourcePv: FunctionComponent<IProps> = memo(function SourcePv({
  data,
}) {
  const intl = useIntl();

  return <>
    <Source
      name={intl.formatMessage({
        id: "site__control__pv__name",
        defaultMessage: "Photovoltaics",
      })}
      offline={!data}
      {...data}
    >
      {data && <>
      <SourceMetric
        secondary
        name={intl.formatMessage({
          id: "site__control__pv__output",
          defaultMessage: "Output",
        })}
        value={data.power}
        unit="%"
      />
      <SourceMetric
        name={intl.formatMessage({
          id: "site__control__pv__dc_voltage",
          defaultMessage: "DC voltage",
        })}
        value={data.metrics?.v_dc_voltage}
        unit="V"
      />
      </>}
    </Source>
  </>
}, isEqual);

export default SourcePv;
